var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownActiveArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84 5.44a.445.445 0 00-.292.118L3.63 8.476a.458.458 0 000 .643.458.458 0 00.642 0l2.625-2.627 2.625 2.627a.458.458 0 00.642 0 .458.458 0 000-.643L7.248 5.558c-.233-.059-.35-.117-.408-.117z",
    fill: "#27AE60"
  })));
}
export default SvgDropdownActiveArrow;